import { mdiBookmark } from '@mdi/js'
import { Icon } from '@mdi/react'
import type { IconProps } from '.'

const Bookmarked = (props: IconProps) => {
    const { filled, color, size = 1, title, ...other } = props
    return (
        <Icon
            data-testid="IconButton__Bookmarked"
            path={mdiBookmark}
            title={title}
            size={size}
            color={color}
            {...other}
        />
    )
}

export default Bookmarked
